<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <a slot="brand" class="navbar-brand mr-lg-5" href="#">
                <img src="img/brand/icon-new.png">
            </a>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <a href="#">
                        <img src="img/brand/icon-new-2.png">
                    </a>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
                <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
                    <a slot="title" href="#" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Services</span>
                    </a>
                    <div class="dropdown-menu-inner">
                        <a href="#title-id" v-smooth-scroll="{ duration: 1000, offset: -50 }"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-primary rounded-circle text-white">
                                <i class="ni ni-app"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h6 class="heading text-primary mb-md-1">Details</h6>
                                <p class="description d-none d-md-inline-block mb-0">Find out more what we are capable of.</p>
                            </div>
                        </a>
                        <a href="#contact-id" v-smooth-scroll="{ duration: 1000, offset: -50 }"
                           class="media d-flex align-items-center">
                            <div class="icon icon-shape bg-gradient-warning rounded-circle text-white">
                                <i class="ni ni-ruler-pencil"></i>
                            </div>
                            <div class="media-body ml-3">
                                <h5 class="heading text-warning mb-md-1">Contact</h5>
                                <p class="description d-none d-md-inline-block mb-0">Further information, please contact us here.</p>
                            </div>
                        </a>
                    </div>
                </base-dropdown>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.facebook.com/MappicoGISLAB/" target="_blank"
                       data-toggle="tooltip" title="Like us on Facebook">
                        <i class="fa fa-facebook-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Facebook</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-icon" href="https://www.linkedin.com/company/mappico" target="_blank"
                       data-toggle="tooltip" title="Connect with us on Linkedin">
                        <i class="fa fa-linkedin-square"></i>
                        <span class="nav-link-inner--text d-lg-none">Linkedin</span>
                    </a>
                </li>
                <li class="nav-item mappico-login-menu">
                    <!-- <a class="nav-link nav-link-icon" href="https://ht.mappico.co.th/" target="_blank"
                       data-toggle="tooltip" title="Like us on Facebook">
                        <i class="ni ni-button-power"></i>
                        <span class="nav-link-inner--text d-lg-none">Log in</span>
                    </a> -->
                     <base-button block size="sm" outline type="danger" icon="ni ni-button-power" tag="a" href="https://ht.mappico.co.th/login.html">Log IN</base-button>
                </li>
                <li class="nav-item d-none d-lg-block ml-lg-4">
                    <a href="https://ht.mappico.co.th/login.html" target="_blank"
                       class="btn btn-neutral btn-icon">
                <span class="btn-inner--icon">
                  <i class="ni ni-button-power mr-2" style="color: #f5365c"></i>
                </span>
                        <span class="nav-link-inner--text" style="color: #f5365c">Log in</span>
                    </a>
                </li>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
